import { useEffect } from 'react';
import { SEOHead } from '../utils/seo';

interface SEOProps {
  title: string;
  description: string;
  url: string;
  type?: 'website' | 'article';
  image?: string;
}

const SEO: React.FC<SEOProps> = (props) => {
  useEffect(() => {
    // Update document title
    document.title = `${props.title} | GameObsidian`;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', props.description);
    }

    // Update or create Open Graph tags
    const updateMetaTag = (property: string, content: string) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    };

    const fullUrl = `https://gameobsidian.com${props.url}`;
    const imageUrl = props.image || 'https://gameobsidian.com/images/logo.webp';

    updateMetaTag('og:title', props.title);
    updateMetaTag('og:description', props.description);
    updateMetaTag('og:url', fullUrl);
    updateMetaTag('og:type', props.type || 'website');
    updateMetaTag('og:image', imageUrl);

    // Update canonical link
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullUrl);
  }, [props]);

  return null;
};

export default SEO;

